import Provider from './src/provider'
import { loadQualtricsScript } from './src/components/QualtricsScript'

export const onRouteUpdate = (obj) => {
  let hashId = document.getElementById('hashLinkContainer')
  if (hashId) {
    hashId.setAttribute('hashlink', obj.location.pathname)
  }

  loadQualtricsScript()
}

export const wrapRootElement = Provider
